/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Domain_Manager_Creator_Limit_MsgInputs */

const en_domain_manager_creator_limit_msg = /** @type {(inputs: Domain_Manager_Creator_Limit_MsgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only one custom domain is permitted on the Creator tier.`)
};

const es_domain_manager_creator_limit_msg = /** @type {(inputs: Domain_Manager_Creator_Limit_MsgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo se permite un dominio personalizado en el plan Creator.`)
};

const fr_domain_manager_creator_limit_msg = /** @type {(inputs: Domain_Manager_Creator_Limit_MsgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un seul domaine personnalisé est autorisé avec le forfait Creator.`)
};

const de_domain_manager_creator_limit_msg = /** @type {(inputs: Domain_Manager_Creator_Limit_MsgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Im Creator-Plan ist nur eine benutzerdefinierte Domain zulässig.`)
};

/** @type {(inputs: Domain_Manager_Creator_Limit_MsgInputs) => LocalizedString} */
const ja_domain_manager_creator_limit_msg = en_domain_manager_creator_limit_msg;

/** @type {(inputs: Domain_Manager_Creator_Limit_MsgInputs) => LocalizedString} */
const zh_domain_manager_creator_limit_msg = en_domain_manager_creator_limit_msg;

/** @type {(inputs: Domain_Manager_Creator_Limit_MsgInputs) => LocalizedString} */
const ar_domain_manager_creator_limit_msg = en_domain_manager_creator_limit_msg;

/** @type {(inputs: Domain_Manager_Creator_Limit_MsgInputs) => LocalizedString} */
const id_domain_manager_creator_limit_msg = en_domain_manager_creator_limit_msg;

/** @type {(inputs: Domain_Manager_Creator_Limit_MsgInputs) => LocalizedString} */
const it_domain_manager_creator_limit_msg = en_domain_manager_creator_limit_msg;

/** @type {(inputs: Domain_Manager_Creator_Limit_MsgInputs) => LocalizedString} */
const ru_domain_manager_creator_limit_msg = en_domain_manager_creator_limit_msg;

/** @type {(inputs: Domain_Manager_Creator_Limit_MsgInputs) => LocalizedString} */
const pt_domain_manager_creator_limit_msg = en_domain_manager_creator_limit_msg;

/** @type {(inputs: Domain_Manager_Creator_Limit_MsgInputs) => LocalizedString} */
const ko_domain_manager_creator_limit_msg = en_domain_manager_creator_limit_msg;

/**
* | output |
* | --- |
* | "Only one custom domain is permitted on the Creator tier." |
*
* @param {Domain_Manager_Creator_Limit_MsgInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const domain_manager_creator_limit_msg = /** @type {((inputs?: Domain_Manager_Creator_Limit_MsgInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Domain_Manager_Creator_Limit_MsgInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_domain_manager_creator_limit_msg(inputs)
	if (locale === "es") return es_domain_manager_creator_limit_msg(inputs)
	if (locale === "fr") return fr_domain_manager_creator_limit_msg(inputs)
	if (locale === "de") return de_domain_manager_creator_limit_msg(inputs)
	if (locale === "ja") return ja_domain_manager_creator_limit_msg(inputs)
	if (locale === "zh") return zh_domain_manager_creator_limit_msg(inputs)
	if (locale === "ar") return ar_domain_manager_creator_limit_msg(inputs)
	if (locale === "id") return id_domain_manager_creator_limit_msg(inputs)
	if (locale === "it") return it_domain_manager_creator_limit_msg(inputs)
	if (locale === "ru") return ru_domain_manager_creator_limit_msg(inputs)
	if (locale === "pt") return pt_domain_manager_creator_limit_msg(inputs)
	return ko_domain_manager_creator_limit_msg(inputs)
});